module.exports = __webpack_public_path__ + "static/service-shape4-a03fcaed52537870ff147fcdf4a49c5d.png";